<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="97.4%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>심리 테스트 번들정보</v-toolbar-title>
        <v-spacer/>
    </v-toolbar>
    <v-list>
        <!-- 유저 아이디  -->
        <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">제목</v-card-title></span>        
        <span style="width:400px">
        <v-text-field
            label="심리테스트 제목"
            v-model="bundle_info.title"
            value=""            
        ></v-text-field> 
        </span>
        </v-list-item>      
        <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">부가설명</v-card-title></span>        
        <span style="width:674px">
        <v-textarea
          outlined
          name="input-7-4"
          label="부가설명 멘트입력"
          v-model="bundle_info.desc_text" 
          style="margin-left: 0px;margin-right: 0px; color: gray;"
        ></v-textarea>
        </span>
        </v-list-item>      
        
        <v-list-item>
            <span style="width:160px"><v-card-title style="font-weight:bold">작은 배너</v-card-title></span>        
            <span>
                <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+bundle_bannerpath_small" alt="Image"  style="width: 120px; height: 60px;">
            </span>
            <span></span>        
            <v-col cols="12" md="6">
            <v-file-input
            hide-details
            outlined
            @change="handleFileChange_small"
            >
            <template #label>
                배너이미지 변경하기 (200*120)
            </template>
            </v-file-input>
                </v-col>
        </v-list-item>      
        <v-list-item>
            <span style="width:160px"><v-card-title style="font-weight:bold">큰 배너</v-card-title></span>        
            <span>
                <img :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+bundle_bannerpath_big" alt="Image"  style="width: 120px; height: 60px;">
            </span>
            <span></span>        
            <v-col cols="12" md="6">
            <v-file-input
            hide-details
            outlined
            @change="handleFileChange_big"
            >
            <template #label>
                큰 배너이미지 변경하기 (400*240)
            </template>
            </v-file-input>
                </v-col>
        </v-list-item>      
        <v-list-item>
            <span style="width:160px"><v-card-title style="font-weight:bold">카테고리 타입</v-card-title></span>        
            <span ><v-card-title style="font-weight:bold; color: brown;">{{ bundle_info.category == 0?'[심리테스트]':'[찍기퀴즈]' }}</v-card-title></span>        
        </v-list-item>
        <v-list-item style="display: flex; justify-content: center; align-items: center;">
            <!-- <v-btn width="120px"
                color="red"
                class='white--text'
                @click="OnDeleteBundle()">삭제하기</v-btn>
                <span style="width:30px"></span> -->
                <v-btn width="120px"
                color="blue"
                class='white--text'
                @click="OnSaveTestBundle()">저장하기</v-btn>
                <span style="width:30px"></span>
                <v-btn width="120px"
                :color="bundle_info.dt_update > bundle_info.dt_commit ? 'purple' : 'grey'"                     
                :class="bundle_info.dt_update > bundle_info.dt_commit ? 'white--text' : 'black--text'"
                @click="OnCommitBundle()">커밋하기</v-btn>
        </v-list-item>


    </v-list>
    </v-card>

    <div style="height:20px"></div>

    <div class="d-flex justify-center">
        <v-card
            class="mx-auto"
            width="50%"
        >
        <v-toolbar
            :color="'light-blue darken-3'"
            dark
        >    
        <v-toolbar-title>심리 테스트 리스트 [ {{get_min_score}} ~ {{get_max_score}} ]</v-toolbar-title>
            <v-spacer/>
            <v-btn
                color="cyan"
                small
                fab
                @click="OnClick_CreateItem"
            >
                <v-icon 
                color= "white"
                >mdi-plus</v-icon>
            </v-btn>
        </v-toolbar>

        <v-list>
            <v-data-table
                :footer-props="{'items-per-page-options': [20, 50, -1]}"
                :headers="headers"
                :items="item_list_all"
                :loading="loadingData"
            >
                <template v-slot:item="{ item, index }">
                <tr>
                    <!-- Index 표시 (1부터 시작) -->
                    <td><v-col style="width: 60px;">{{ index + 1 }}</v-col></td>
                    <td>
                        {{item.test_data.title}}
                    </td>
                    <td>
                    {{item.need_ad == 0 ? '없음' :'광고'}}
                    </td>
                    <td>
                    <v-btn
                        width="60px"
                        color="red"
                        class="white--text"
                        @click="OnDeleteQuiz_Item(item)"
                    >
                        삭제
                    </v-btn>
                    </td>

                    <!-- 수정 버튼 -->
                    <td>
                    <v-btn
                        width="60px"
                        color="blue"
                        class="white--text"
                        @click="OnEditTest(item)"
                    >
                        수정
                    </v-btn>
                    </td>
                </tr>
                </template>
            </v-data-table>
            </v-list>

        </v-card>
        <v-card
            class="mx-auto"
            width="45%"
        >
        <v-toolbar
            :color="'indigo darken-2'"
            dark
        >    
        <v-toolbar-title>테스트 결과 리스트 </v-toolbar-title>
            <v-spacer/>
            <v-btn
                color="indigo lighten-2"
                small
                fab
                @click="OnClick_CreateItemResult"
            >
                <v-icon 
                color= "white"
                >mdi-plus</v-icon>
            </v-btn>
        </v-toolbar>

        <v-list>
            <v-data-table
                :footer-props="{'items-per-page-options': [-1]}"
                :headers="result_headers"
                :items="result_list_all"
                :loading="loadingData"
            >
                <template v-slot:item="{ item, index }">
                <tr>
                    <!-- Index 표시 (1부터 시작) -->
                    <td><v-col style="width: 60px;">{{ result_list_all.length - ( index) }}</v-col></td>
                    <td>
                        {{item.title}}
                    </td>
                    <td>
                        {{item.score_start}} ~ {{item.score_end}}
                    </td>
                    <td  style="width: 120px;">
                    <img
                        :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.img_path" 
                        alt="Image"
                        style="width: 120px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"
                    />
                    </td>
                    <td  style="width: 60px;">
                    <v-btn
                        width="60px"
                        color="red"
                        class="white--text"
                        @click="OnDeleteQuiz_Item_Result(item)"
                    >
                        삭제
                    </v-btn>
                    </td>

                    <!-- 수정 버튼 -->
                    <td  style="width: 60px;">
                    <v-btn
                        width="60px"
                        color="blue"
                        class="white--text"
                        @click="OnEditTest_Result(item)"
                    >
                        수정
                    </v-btn>
                    </td>
                </tr>
                </template>
            </v-data-table>
            </v-list>

        </v-card>
    </div>

    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3 font-weight-bold text-center">
            {{dialog_state_text}}
        </v-card-title>
        <v-card-text>
        <v-row  style="height:60px">
        <v-col><v-text-field 
                background-color="#D4F4FA"
                label="문제를 입력해주세요"
                v-model="dialog_title_text" 
                outlined
                dense
            ></v-text-field></v-col>
    </v-row>
      
    <div style="height:50px"></div>
    <v-radio-group v-model="dialog_quiz_correct_index" row>
    <v-row   style="height:60px"  v-for="(item, index) in dialog_answers" :key="index">
        <v-col><v-text-field 
                label="선택지와 배점을 입력해주세요"
                v-model="dialog_answers[index]" 
                outlined
                dense
            ></v-text-field></v-col>
            <v-col cols="2" v-if="bundle_info.category == 0">
                <v-text-field 
                    label="배점"
                    v-model="dialog_answers_point[index]" 
                    outlined
                    dense
                    >
                </v-text-field>
            </v-col>
            <v-col cols="3"  v-if="bundle_info.category == 1">
                <v-radio label="정답" :value="index"   style="height:40px"></v-radio>        
            </v-col>
    </v-row>
    </v-radio-group>
    <v-row>
        <v-col  cols="3"  class="text-center font-weight-bold text-h6">광고 여부</v-col>
        <v-col>
            <v-checkbox
      v-model="dialog_checkbox"
      label="(활성화 : 테스트 선택시 광고가 나옵니다)"
      class="my-auto"
    ></v-checkbox>
        </v-col>
    </v-row>
      
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="CreatTest"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_result"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3 font-weight-bold text-center">
            {{dialog_result_state_text}}
        </v-card-title>
        <v-card-text>
        <v-row  style="height:60px">
        <v-col><v-text-field 
                background-color="#D4F4FA"
                label="결과 타이틀 입력"
                v-model="dialog_result_title_text" 
                outlined
                dense
            ></v-text-field></v-col>
    </v-row>
      
    <div style="height:50px"></div>

    <v-row>
        <v-textarea
          outlined
          name="input-7-4"
          label="결과 설명 입력"
          v-model="dialog_result_desc_text" 
          style="margin-left: 13px;margin-right: 13px; color: gray;"
        ></v-textarea>
    </v-row>
    <v-row>
           <v-col cols="4"><v-text-field 
                label="스코어 Min"
                v-model="dialog_result_score_min" 
                outlined
                dense
            ></v-text-field></v-col>
            <v-col cols="4"><v-text-field 
                label="스코어 Max"
                v-model="dialog_result_score_max" 
                outlined
                dense
            ></v-text-field></v-col></v-row>
            * min 포함 max 미포함
    <v-row>
        <!-- <v-col  cols="3"  class="text-center font-weight-bold text-h6">광고 여부</v-col> -->
        <v-col>
            <img
                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+dialog_result_data.img_path" 
                    alt="Image"
                    style="width: 120px; height: 120px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"
                    v-if="dialog_result_data != {}"
                />
                <v-file-input
                    height="10px"
                    hide-details
                    outlined
                    v-model="dialog_result_bannerImage"
                    dense
                    style=" margin-bottom: 5px;"
                >
                    <template #label>결과이미지 등록</template>
                </v-file-input>
        </v-col>
    </v-row>
      
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="CreatTest_Result"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
const { s3_upload , FileUpload_Async, FileUpload_JSON } = require("../../util/fileutil");
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        bundle_bannerpath_small :'',
        bundle_bannerpath_big :'',
        bundle_info:{},

        imageFile_small : null, 
        imageFile_big: null,


        dialog_state_text:'문제 등록하기',
        dialog_title_text :'',
        dialog_checkbox: false,
        dialog_test_data : {},
        dialog_answers:Array.from({ length: 5 }, () => ''),
        dialog_answers_point:Array.from({ length: 5 }, () => ''),
        dialog : false,
        dialog_mode_is_edit : false,
        dialog_selected_edit_pid : 0,
        dialog_quiz_correct_index:0,
        

        dialog_result:false,
        dialog_result_state_text:'결과 등록하기',   
        dialog_result_title_text :'',
        dialog_result_desc_text:'',
        dialog_result_score_min:0,
        dialog_result_score_max:1,        
        dialog_result_mode_is_edit : false,
        dialog_result_data  : 0,
        dialog_result_bannerImage:null,
        

        loadingData:false,        
        create_date:'',
        quiz_title_text : '',

        headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '타이틀', value: 'category' },            
            { text: '광고여부', value: 'need_ad' },
            { text: '삭제', value: 'delete' },
            { text: '수정', value: 'edit' },
        ],
        result_headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '결과', value: 'category' },    
            { text: '점수구간', value: 'category' },            
            { text: '배너', value: 'need_ad' },
            { text: '삭제', value: 'delete' },
            { text: '수정', value: 'edit' },
        ],
        item_list_all:[
        ],
        result_list_all:[
        ],

        quiz_dic_for_pid:{

        },
        checkbox_state_container:{},

        selected_editing_item:{},
        resultImageFiles:{},
    }),

    created()
    {    
        this.LoadBundleInfo(this.$route.query.pid);    
        this.LoadItemList(this.$route.query.pid);
        this.LoadResultList(this.$route.query.pid);
    },


    methods:{
        ...mapActions([
            'SET_TESTBUNDLE_MAIN',
            'GET_TESTBUNDLE_MAIN',
            'GET_TESTBUNDLE_INFO',
            'EDIT_TESTBUNDLE',
            'DELETE_TESTBUNDLE',
            'COMMIT_TESTBUNDLE',

            'CREATE_TEST',
            'GET_TEST_LIST',
            'DELETE_TEST',
            'EDIT_TEST',

            'GET_TEST_LIST_RESULT',
            'CREATE_TEST_RESULT',
            'DELETE_TEST_RESULT',
            'EDIT_TEST_RESULT',
        ]),
        LoadBundleInfo(pid){   
            this.GET_TESTBUNDLE_INFO({pid}).then((body_data)=>{
                this.bundle_info = body_data.result;
                this.bundle_bannerpath_small = body_data.result.img_path_small;
                this.bundle_bannerpath_big = body_data.result.img_path_big;
                this.bundle_title = body_data.result.title;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            });           
        },
        LoadItemList(bundle_pid)
        {
            this.GET_TEST_LIST({bundle_pid}).then((body_data)=>{
                this.item_list_all = body_data.result;
                // this.item_list_all.forEach((item) => {
                //     // this.checkbox_state_container[item.pid] = item.need_ad == 0 ? false: true; // 초기값을 false로 설정
                // });
            }).catch((err)=>{

            });
        },
        LoadResultList(bundle_pid)
        {
            this.resultImageFiles = {};
            this.checkbox_state_container = {};
            this.GET_TEST_LIST_RESULT({bundle_pid}).then((body_data)=>{
                this.result_list_all = body_data.result.sort((a, b) =>  b.pid - a.pid);
                //console.log("불러온 결과 리스트 " + JSON.stringify(this.result_list_all));
                this.result_list_all.forEach((item) => {
                    this.resultImageFiles[item.pid] = null;
                });
            }).catch((err)=>{

            });
        },
        CreatTest()
        {
            console.log("CreatTest  " +this.dialog_quiz_correct_index );
            //this.dialog_title_text = this.dialog_title_text.replace(/\s/g, '');
            let answers = [];
            //foreach(item in this.dialog_answers)=>{}
            for(let i=0 ; i < this.dialog_answers.length ; i++)
            {
                let item = this.dialog_answers[i];
                if(item != "")
                {
                    
                    let resultItem = {};
                    resultItem['item'] = this.dialog_answers[i];
                    if(this.bundle_info.category == 1)
                    {
                        let score = (this.dialog_quiz_correct_index == i)?1:0;
                        resultItem['score'] = score;
                    }   
                    else{
                        let score = this.dialog_answers_point[i]==''?0:parseInt(this.dialog_answers_point[i]);
                        resultItem['score'] = score;
                    }
                    answers.push(resultItem);
                }                
            }
            if(this.bundle_info.category == 1)
            {
                let isContain_Correct = false;
                for(let i=0 ; i < answers.length ; i++)
                {
                    let item = answers[i];
                    if(item.score != 0)
                    {
                        isContain_Correct = true;
                        break;
                    }
                }
                if(!isContain_Correct)
                {
                    alert("정답 정보가 잘못됬습니다.");
                    return;
                }
            }


            if(this.dialog_title_text.replace(/\s/g, '') == "")
            {
                alert("미입력한 정보가 있습니다.");
                return;
            }
            if(answers.length <= 0)
            {
                alert("적어도 하나이상의 답변이 있어야합니다.");
                return;
            }
            
            let test_data = {};
            test_data["title"] = this.dialog_title_text;
            test_data["answers"] = answers;
            
            this.loadingData = true;
            this.dialog = false;    
            this.loadingData = false;
            
            let need_ad = this.dialog_checkbox ? 1:0;       
            let bundle_pid = this.$route.query.pid;            

            if(this.dialog_mode_is_edit )
            {//수정모드 
                console.log("체크박스 상태 : " + this.dialog_checkbox   + "  "  + need_ad);
                let pid = this.dialog_selected_edit_pid;
                this.EDIT_TEST({ bundle_pid,  pid ,test_data , need_ad}).then((body_data)=>{
                    this.LoadItemList(this.$route.query.pid);
                    this.LoadBundleInfo(this.$route.query.pid);    
                });                                       

            }
            else{
                this.CREATE_TEST({ bundle_pid ,test_data , need_ad}).then((body_data)=>{
                    this.LoadItemList(this.$route.query.pid);
                    this.LoadBundleInfo(this.$route.query.pid);    
                });                                       
            }
        },
        async CreatTest_Result()
        {
            //this.dialog_result_title_text = ;
           
            if(this.dialog_result_title_text.replace(/\s/g, '') == "" && this.dialog_result_desc_text == "")
            {
                alert("미입력한 정보가 있습니다.");
                return;
            }
          
            this.dialog_result = false;    
            //bundle_pid , title, desc, img_path , score_start, score_end
            let bundle_pid = this.$route.query.pid;            
            let title = this.dialog_result_title_text;
            let desc = this.dialog_result_desc_text;    
            let score_start = this.dialog_result_score_min;
            let score_end = this.dialog_result_score_max;
            let img_path  = "";
            
            
            if(this.dialog_result_bannerImage != null)
            {
                img_path = "snapquiz/test_img/"+this.$route.query.pid+"/"+this.Utill_CreateNewImageName(this.dialog_result_bannerImage.name);
                await FileUpload_Async(this.dialog_result_bannerImage, img_path);
                this.dialog_result_bannerImage = null;
            }else{
                img_path = this.dialog_result_data == "" ? "" : this.dialog_result_data.img_path;
            }

            if(this.dialog_result_mode_is_edit )
            {//수정모드 
                let pid = this.dialog_result_data.pid;
                console.log("this.EDIT_TEST_RESULT " + bundle_pid + "  " + title + "  " + desc + "  " + img_path + "  " + score_start + "  " + score_end);
                this.EDIT_TEST_RESULT({ bundle_pid , pid,title, desc, img_path , score_start, score_end }).then((body_data)=>{
                    this.LoadItemList(this.$route.query.pid);
                    this.LoadResultList(this.$route.query.pid);    
                });                                       
            }
            else{
                console.log("this.CREATE_TEST_RESULT " + bundle_pid + "  " + title + "  " + desc + "  " + img_path + "  " + score_start + "  " + score_end);
                this.CREATE_TEST_RESULT({ bundle_pid , title, desc, img_path , score_start, score_end}).then((body_data)=>{
                    this.LoadItemList(this.$route.query.pid);
                    this.LoadResultList(this.$route.query.pid);    
                });                                       
            }
        },

        handleFileChange_small(file)
        {
            this.imageFile_small = file;            
        },

        handleFileChange_big(file)
        {
            this.imageFile_big = file;            
        },
      
        OnDeleteQuiz_Item(item)
        {
               // 기본 confirm 사용
               if (confirm("정말 삭제하시겠습니까?")) {
                    let pid = item.pid;
                    let bundle_pid = this.$route.query.pid;

                    // 삭제 로직 실행
                    this.DELETE_TEST({ bundle_pid, pid }).then((body_data) => {
                        this.LoadBundleInfo(this.$route.query.pid);    
                        this.LoadItemList(this.$route.query.pid);
                    }).catch((error) => {
                        console.error("삭제 실패:", error);
                    });
                } else {
                    // 취소를 누른 경우
                    console.log("삭제가 취소되었습니다.");
                }
        },
        OnDeleteQuiz_Item_Result(item)
        {
               // 기본 confirm 사용
               if (confirm("정말 삭제하시겠습니까?")) {
                    let pid = item.pid;
                    let bundle_pid = this.$route.query.pid;
                    this.DELETE_TEST_RESULT({ bundle_pid, pid }).then((body_data) => {
                        this.LoadBundleInfo(this.$route.query.pid);    
                        this.LoadResultList(this.$route.query.pid);
                    }).catch((error) => {
                        console.error("삭제 실패:", error);
                    });
                } else {
                    // 취소를 누른 경우
                    console.log("삭제가 취소되었습니다.");
                }
        },
        OnClick_CreateItem()
        {
            // 디폴트 시간을 넣어준다.
            this.dialog_mode_is_edit = false;
            this.dialog_title_text = "";
            this.dialog_checkbox = false;
            this.dialog_answers = Array.from({ length: 5 }, () => '');
            this.dialog_answers_point = Array.from({ length: 5 }, () => '');
            this.dialog = true;
        },

        OnClick_CreateItemResult()
        {
            this.dialog_result_mode_is_edit = false;
            this.dialog_result_state_text = "결과 등록하기";
            this.dialog_result_title_text = '';
            this.dialog_result_desc_text = ''; 
            this.dialog_result_bannerImage = null;
            this.dialog_result_score_min = 0;
            this.dialog_result_score_max = 1;        
            this.dialog_result_data = {};
            this.dialog_result = true;

            // this.dialog_result_title_text = "";
            // this.dialog_result_desc_text = "";
        },
        CancelEdit()
        {
            this.dialog = false;    
            this.dialog_result = false;
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },
    
        OnEditTest(item) {
            this.dialog_selected_edit_pid = item.pid;
            this.dialog_mode_is_edit = true;
            this.dialog_title_text = item.test_data.title;
            //= item.test_data.category;

            // Ensure the type is a number
            const needAdValue = Number(item.need_ad) == 0 ? false: true;
            this.dialog_answers = Array.from({ length: 5 }, () => '');
            this.dialog_answers_point = Array.from({ length: 5 }, () => '');
            console.log(JSON.stringify(item));

            for (let i = 0; i < 5; i++) {
                if (i < item.test_data.answers.length) {
                    this.dialog_answers[i] = item.test_data.answers[i].item;
                    this.dialog_answers_point[i] = item.test_data.answers[i].score;
                    if(this.bundle_info.category == 1)
                    {
                        if(item.test_data.answers[i].score == 1)
                        {
                            this.dialog_quiz_correct_index = i;
                        }
                    }
                } else {
                    this.dialog_answers[i] = '';
                    this.dialog_answers_point[i] = '';
                }
            }
            this.dialog = true;
        }, 
        OnEditTest_Result(item) {
            this.dialog_result_mode_is_edit = true;
            this.dialog_result_data = item;
            this.dialog_result_title_text = item.title;
            this.dialog_result_desc_text = item.desc_text;
            this.dialog_result_score_min = item.score_start;
            this.dialog_result_score_max = item.score_end;
            this.dialog_result_bannerImage = null;
            this.dialog_result = true;
        },
        
        OnDeleteBundle(){
          // 기본 confirm 사용
          if (confirm("정말 테스트를 삭제하시겠습니까?")) {
                    let pid = this.$route.query.pid;

                    // 삭제 로직 실행
                    this.DELETE_TESTBUNDLE({ pid }).then((body_data) => {
                        this.$router.push({path: '/testlist',});
                    }).catch((error) => {
                        console.error("삭제 실패:", error);
                    });
                } else {
                    // 취소를 누른 경우
                    console.log("삭제가 취소되었습니다.");
                }            
        },
        async OnCommitBundle(){
            //this.LoadQuizBundleInfo();                        
            this.loadingData = true; 
            var newFileName = this.bundle_info.commit_path;
            if(newFileName == "")
                newFileName = "snapquiz/test_data/"+this.Utill_CreateNewImageName('temp.json');            
            let data_list = this.item_list_all;
            let result_list = this.result_list_all;
            console.log("Commit_ _ 1");
            let data_container = {"test_data":data_list, "result_data":result_list};   


            if(await FileUpload_JSON(data_container, newFileName))
            {
                console.log("Commit_ _ 2");
                    this.loadingData = false;
                    let pid = this.$route.query.pid;        
                    let commit_path = newFileName;       
                    this.COMMIT_TESTBUNDLE({pid, commit_path}).then((body_data)=>{
                        console.log("Commit_ _ 3");
                        this.LoadBundleInfo(this.$route.query.pid);                        
                    }).catch((err)=>{});
            }
        },
        async OnSaveTestBundle()
        {           
            let img_path_small = '';
            let img_path_big = '';
            if(this.imageFile_small != null)
            {
                img_path_small = "snapquiz/test_img/banner/"+this.Utill_CreateNewImageName(this.imageFile_small.name);        
                await FileUpload_Async(this.imageFile_small, img_path_small);
            }
            if(this.imageFile_big != null)
            {
                img_path_big = "snapquiz/test_img/banner/"+this.Utill_CreateNewImageName(this.imageFile_big.name);        
                await FileUpload_Async(this.imageFile_big, img_path_big);
            }
            // console.log("SMALL : https://content-filecenter.s3.ap-northeast-2.amazonaws.com/" + img_path_small);
            // console.log("BIG  : https://content-filecenter.s3.ap-northeast-2.amazonaws.com/" + img_path_big);
            let pid = this.$route.query.pid;
            let title  = this.bundle_info.title;
            if(img_path_small == "")
            {
                img_path_small = this.bundle_info.img_path_small;
            }
            if(img_path_big == "")
            {
                img_path_big = this.bundle_info.img_path_big;            
            }
            let test_count =  this.bundle_info.test_count;
            let is_main =  this.bundle_info.is_main;
            let participants =  this.bundle_info.participants;
            let category =  this.bundle_info.category;
            let desc_text =  this.bundle_info.desc_text;
            this.EDIT_TESTBUNDLE({pid, title,desc_text  , img_path_small , img_path_big ,  test_count , is_main , participants , category}).then((body_data)=>{
                this.LoadBundleInfo(this.$route.query.pid);    
                this.LoadItemList(this.$route.query.pid);
            });       
        },
        
    },
    computed: {
        isLive(){
            return config.isLive;
        },     
        is_checked(item)
        {
            return item.need_ad == 0 ?false:true;
        },
        get_min_score()
        {
            return this.item_list_all.reduce((minSum, item) => {
                if (item.test_data && item.test_data.answers) {
                    const minScore = Math.min(...item.test_data.answers.map(answer => answer.score));
                    return minSum + minScore;
                }
                return minSum;
            }, 0);
        },
        get_max_score()
        {
            return this.item_list_all.reduce((maxSum, item) => {
                if (item.test_data && item.test_data.answers) {
                    const maxScore = Math.max(...item.test_data.answers.map(answer => answer.score));
                    return maxSum + maxScore;
                }
                return maxSum;
            }, 0);
        },
    },
    components:{
    },
    watch :{

    }
};
</script>



<style scoped>
.custom-row-spacing {
  margin-bottom: 4px;
}


</style>